<script>

    import { createEventDispatcher } from 'svelte'

    import UtilsMethods from '../$methods/utils.methods'
    
    export let provider = ''
    export let isLabel = true

    const providers = UtilsMethods.getProviders()
    const dispatch = createEventDispatcher()

    function onSelect() {
        dispatch('select')
    }

</script>

<!-- svelte-ignore a11y-no-onchange -->
 
<div class="field app-select-field">
    {#if isLabel}
        <label for="" class="label">Proveedor</label>
    {/if}
    <div class="control">
        <div class="select is-fullwidth">
            <select bind:value={provider} on:change={onSelect} on:change>
                <option value="">Proveedor</option>
                {#each providers as provider}
                    <option value="{ provider }">{ provider }</option>
                {/each}
            </select>
        </div>
    </div>
</div>

<style>
    .app-select-field {
        width: 100%;
        min-width: 0;
    }

    .app-select-field .control {
        width: 100%;
    }
</style>